export const CONSTANTS = {
    INVALID_CREDENTIALS: 'We didn\'t recognize the username or password you entered. Please try again.',
    INVALID_ACCOUNT: 'Your CS admin account is in a disabled/inactive status. Please raise a new access ticket on Service Marketplace.',
    LOGIN_EXECEPTION: 'Exception occurred while connecting to Active Directory. Please contact Helpdesk.',
    HOME_URL: '/home',
    USER_ID_FIELD: 'userId',
    PASSWORD_FIELD: 'password',
    EMPTY: '',
    UNAUTHORIZED_CODE: '601',
    ACCOUNT_INACTIVE_CODE: '603',
    USER_NOT_FOUND_CODE: '404',
    SALESFORCE_SSO_USER: 'SALESFORCE_SSO_USER',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    UNAUTHORIZED_ACCESS: 'UNAUTHORIZED ACCESS',
    UNAUTHORIZED_AUDIT_TXT: 'Unauthorized access attempt to'
};

export const SPLUNK = {
    LOGIN_SUCCESS_ID: '1102',
    LOGIN_FAILURE_ID: '1103',
    USER_PROFILE_SUCCESS_ID: '1104',
    USER_PROFILE_FAILURE_ID: '1105',
    SALES_FORCE_SSO_SUCCESS_ID: '1106',
    SALES_FORCE_SSO_FAILURE_ID: '1107',
    UNAUTH_URL_ACCESS_ATTEMPT_ID: '1108',
    LOGIN_SUCCESS_EVENT_CD: 'DPADMIN_LOGIN_SUCCESS',
    LOGIN_FAILURE_EVENT_CD: 'DPADMIN_LOGIN_FAILURE',
    USER_PROFILE_SUCCESS_EVENT_CD: 'DPADMIN_USER_PROFILE_SUCCESS',
    USER_PROFILE_FAILURE_EVENT_CD: 'DPADMIN_USER_PROFILE_FAILURE',
    SALES_FORCE_SSO_SUCCESS_EVENT_CD: 'DPADMIN_SALES_FORCE_SSO_SUCCESS',
    SALES_FORCE_SSO_FAILURE_EVENT_CD: 'DPADMIN_SALES_FORCE_SSO_FAILURE',
    UNAUTH_URL_ACCESS_ATTEMPT_CD: 'DPADMIN_URL_UNAUTHORIZED_ACCESS_ATTEMPT',
    LOGIN_SUCCESS_EVENT_DESC: 'DPAdmin Login Successful',
    LOGIN_FAILURE_EVENT_DESC: 'DPAdmin Login Failed',
    USER_PROFILE_SUCCESS_EVENT_DESC: 'DPAdmin User Profile Fetch Success',
    USER_PROFILE_FAILURE_EVENT_DESC: 'DPAdmin User Profile Fetch Failed',
    SALES_FORCE_SSO_SUCCESS_EVENT_DESC: 'Sales Force Inbound SSO Success',
    SALES_FORCE_SSO_FAILURE_EVENT_DESC: 'Sales Force Inbound SSO Failed',
    UNAUTH_URL_ACCESS_ATTEMPT_DESC: 'Unauthorized access attempt to DP Admin authorized URL',
}

export const COOKIE = {
    DP_ADM_USER_NAME: 'DPADMUSR',
    DP_ADM_USER_ID: 'DPADMUID',
    DP_ADM_TOKEN: 'DPADMTKN',
    DP_ADM_SID: 'DPADMSID',
    DP_ADM_AL: 'DPADMAL',
    BENEFIT_LOOKUP_URL: 'benefitLookupUrl'
};